import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '@atmi/shared';
import { FormModule } from '@sim/form';
import { UiModule } from '@ui/ui.module';

import { RoleManagerComponent } from './components/role-manager/role-manager.component';
import { RolesComponent } from './components/roles/roles.component';
import { RoleModuleConfiguration } from './models/configuration';
import { CheckCapabilityPipe } from './pipes/check-capability.pipe';
import { RoleConfigurationService } from './token';

export * from './components/role-manager/role-manager.component';
export * from './components/roles/roles.component';
export * from './models/configuration';
export * from './models/role';
export * from './pipes/check-capability.pipe';
export * from './services/role-api.service';
export * from './services/role.service';
export * from './token';
export * from './utils';

const components = [
  RolesComponent,
  RoleManagerComponent,
];

const pipes = [
  CheckCapabilityPipe,
];

const routes: Routes = [
  {
    children: [
      {
        component: RolesComponent,
        path: '',
      },
      {
        component: RoleManagerComponent,
        path: 'manager',
      }
    ],
    path: '',
  },
];

@NgModule({
  declarations: [
    ...components,
    ...pipes,
  ],
  exports: [
  ],
  imports: [
    CommonModule,
    TranslateModule,
    UiModule,
    FormModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    SharedModule,
    RouterModule.forChild(routes),
  ],
})
export class RoleModule {
  static forRoot(config: RoleModuleConfiguration): ModuleWithProviders<RoleModule> {
    return {
      ngModule: RoleModule,
      providers: [
        { provide: RoleConfigurationService, useValue: config },
      ],
    };
  }
}
